import React from 'react';

const ReportAnalysis = ({ analysis, type }) => {
    if (!analysis) return null;

    return (
        <div className="card border-0 shadow-sm mb-4 bg-primary bg-opacity-10">
            <div className="card-body">
                <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-lightbulb-fill text-primary me-2 fst-normal" style={{ fontSize: '1.2rem' }}></i>
                    <h5 className="card-title mb-0 text-primary">Analyse & Synthèse</h5>
                </div>
                <p className="card-text text-dark mb-0" style={{ fontSize: '1.05rem', lineHeight: '1.6' }}>
                    {analysis}
                </p>
            </div>
        </div>
    );
};

export default ReportAnalysis;
